import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Parts, Types} from "components";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import {Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";

/**
 *  @property {Transactions_Questions_Object} state
 *  @property {object} model
 *  @property {Transactions_Questions_Properties} model.properties
 *  @property {Transactions_Questions_Is} model.is
 *  @property {Transactions_Questions_Has} model.has
 */
export default class DispositionQuestions extends ObjectOverride {
	constructor(props) {
		super(props, Types.Transactions_Questions._name);
		// noinspection JSPrimitiveTypeWrapperUsage
		this.model.properties.under_twenty_one.required = false;
	}

	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		this.setState({pkey: data.pkey});
	}

	form = () => {
		/** @type {Transactions_Questions_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Questions_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset disabled={!!object.pkey}>
					<Parts.DispositionQuestions_August2023
						object={object}
						properties={properties}
						onTextUpdate={this.handleTextFieldPropertyUpdate}
					/>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					{!this.state.pkey && <hr style={{marginBottom: 0}}/>}
				</CardContent>
				{!this.state.pkey && <CardActions className={'text-right'}>
					{/*<Button color="danger" onClick={this.handleDelete}>Delete</Button>*/}
					{!this.state.pkey && <Button color="primary" onClick={this.handleSubmit}>Save</Button>}
				</CardActions>}
			</Card>
		)
	}
}
